import React from "react";
import classNames from "classnames";
var UISwitch = function(param) {
    var className = param.className, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, ariaLabelledby = param.ariaLabelledby, isOn = param.isOn, onSwitch = param.onSwitch;
    var classes = classNames("ui-switch", className, {
        on: isOn,
        off: !isOn,
        "ui-switch--disabled": disabled
    });
    var handleOnKeyDown = function(event) {
        if (event.key !== " " && event.key !== "Enter") return;
        onSwitch(!isOn);
    };
    return /*#__PURE__*/ React.createElement("span", {
        className: classes,
        tabIndex: 0,
        role: "switch",
        "aria-checked": isOn,
        "aria-labelledby": ariaLabelledby,
        onClick: function() {
            return onSwitch(!isOn);
        },
        onKeyDown: handleOnKeyDown
    }, /*#__PURE__*/ React.createElement("span", {
        style: {
            transition: ".3s",
            left: isOn ? "100%" : 0,
            transform: isOn ? "translateX(-100%)" : "translateX(0)"
        },
        className: "ui-switch__handler"
    }));
};
export default UISwitch;
